import { render, staticRenderFns } from "./FormNewOwner.vue?vue&type=template&id=1c07387a&lang=true"
import script from "./FormNewOwner.vue?vue&type=script&lang=js"
export * from "./FormNewOwner.vue?vue&type=script&lang=js"
import style0 from "./FormNewOwner.vue?vue&type=style&index=0&id=1c07387a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports